import css from 'styled-jsx/css'
import { colors } from "app/theme";

export const contractVersionNotAllowedMessageCss = css`
  .general-not-allowed-page-message {
    margin: 1rem auto;
    display: flex;
    justify-content: center;
  }
  .general-not-allowed-page-message-content {
    max-width: 30rem;
    margin: 0 auto;
  }
  .general-not-allowed-page-message-content h3 {
    margin: 0 0.5rem;
  }

  .link {
    color: ${colors.primary};
  }
`
